export default __webpack_public_path__ + "static/media/Prospecting.b497f0e7.svg";